import { Injectable, Type } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DialogOptions } from '../types/dialog-options.type';

@Injectable({
  providedIn: 'root',
})
export class DialogDisplayService {
  private readonly defaultDialogOptions: DialogOptions = {
    theme: 'dark',
    width: '600px',
    height: 'auto',
    maxWidth: '80vw',
    fullFrame: false,
  };

  constructor(private dialog: MatDialog) {}

  public open<R = any>(contentComponent: Type<any>, options: DialogOptions = {}, data: any = {}) {
    // fill in any missing options with defaults
    const dialogOptions = { ...this.defaultDialogOptions, ...options };
    // add the theme to the data object in case the dialog needs it
    const dialogData = { ...data, theme: dialogOptions.theme };

    return this.dialog.open<any, any, R>(contentComponent, {
      data: dialogData,
      width: dialogOptions.width,
      height: dialogOptions.height,
      maxWidth: dialogOptions.maxWidth,
      autoFocus: false,
      panelClass: [
        // styles for every dialog
        'dialog-panel',
        // determines theme-specific color and styling options
        dialogOptions.theme,
        // when the component should fill the whole dialog
        ...(dialogOptions.fullFrame ? ['full-frame'] : []),
      ],
      injector: dialogOptions.injector,
      backdropClass: 'dialog-backdrop',
      closeOnNavigation: true,
      disableClose: true,
    });
  }

  public close() {
    this.dialog.closeAll();
  }
}
